import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import ProgressReport from '../progress_report';
import ExamHistory from '../exam_history';
import SelectQuiz from '../select_quiz';
import Subscription from '../User Subscription';

function UserDetails() {
    const [activeTab, setActiveTab] = useState('progress');
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const renderComponent = () => {
        switch (activeTab) {
            case 'progress':
                return <ProgressReport />;
            case 'exam':
                return <ExamHistory />;
            case 'quiz':
                return <SelectQuiz />;
            case 'subscription':
                return <Subscription />;
            default:
                return <ProgressReport />;
        }
    };

    return (
        <div className="relative max-h-screen bg-gray-100 p-6 overflow-auto ">
            {/* Dropdown Menu */}
            <div className="absolute top-4 right-6">
                <button
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 shadow-md hover:bg-blue-700 transition duration-300"
                >
                    <span>Menu</span>
                    <FaChevronDown className={`transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
                </button>

                {/* Dropdown List */}
                {dropdownOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-lg border border-gray-200">
                        <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-100"
                            onClick={() => { setActiveTab('progress'); setDropdownOpen(false); }}
                        >
                            Progress Report
                        </button>
                        <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-100"
                            onClick={() => { setActiveTab('exam'); setDropdownOpen(false); }}
                        >
                            Exam History
                        </button>
                        <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-100"
                            onClick={() => { setActiveTab('quiz'); setDropdownOpen(false); }}
                        >
                            Result Checker
                        </button>
                        <button
                            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-100"
                            onClick={() => { setActiveTab('subscription'); setDropdownOpen(false); }}
                        >
                            Subscription
                        </button>
                    </div>
                )}
            </div>

            {/* Display Selected Component */}
            <div className="mt-16 max-w-5xl mx-auto bg-white p-6 rounded-lg shadow-lg">
                {renderComponent()}
            </div>
        </div>
    );
}

export default UserDetails;
